import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IsEditableService {

  constructor() { }

  isOrderEditable(typeCase: string, status: string): boolean {
    switch (typeCase) {
      case 'subscription': {
        return status < '1';
      }
      case 'server': {
        return status < '3';
      }
      case 'player': {
        return status < '4';
      }
      case 'network': {
        return status < '3';
      }
      case 'proxy': {
        return status < '3';
      }
      case 'wifi': {
        return status < '3';
      }
      case 'site': {
        return status < '1';
      }
      case 'comments': {
        return status < '4' || status === 'exchange';
      }
      case 'dispatchDate': {
        return status < '5' || status === 'exchange';
      }
      case 'address': {
        return status < '5';
      }
      case 'contact': {
        return status < '5';
      }
      default: {
        return true;
      }
    }
  }

  isSubscriptionEditable(typeCase: string, status: string): boolean {
    switch (typeCase) {
      case 'subscription': {
        return status < '1';
      }
      default: {
        return true;
      }
    }
  }
}
